import type { TableColumnsType } from 'antd';
import * as Yup from 'yup';
import { Translation } from 'react-i18next';
import { REGULATION_TYPE } from '../../constants/regulation-type.tsx';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../constants/app.ts';
import { CONFIRMATION_PERIOD } from '../../constants/confirmation-period.tsx';
import type { RawRegulationsType } from './RawRegulations.types.ts';

export const RAW_REGULATIONS_FORM = 'RawRegulationsForm';

export const RAW_REGULATIONS_COLUMNS: TableColumnsType<RawRegulationsType> = [
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.title')}</>}</Translation>,
    dataIndex: 'title',
    fixed: 'left',
    width: 300,
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.type')}</>}</Translation>,
    dataIndex: 'type',
    width: 150,
    fixed: 'left',
    render: (value: number) => REGULATION_TYPE[value as 1 | 2 | 3],
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.is-active')}</>}</Translation>,
    dataIndex: 'isActive',
    align: 'center',
    render: (value: number) =>
      value ? (
        <Translation>{(t) => <>{t('common.yes')}</>}</Translation>
      ) : (
        <Translation>{(t) => <>{t('common.no')}</>}</Translation>
      ),
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.number')}</>}</Translation>,
    dataIndex: 'regulationNumber',
    width: 200,
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.unit')}</>}</Translation>,
    dataIndex: 'unitInCharge',
    width: 200,
    render: (value: { title: string }) => value?.title,
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.creation')}</>}</Translation>,
    dataIndex: 'creationDate',
    render: (value) => dayjs(value).format(DATE_FORMAT),
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.publication')}</>}</Translation>,
    dataIndex: 'publicationDate',
    render: (value) => (value ? dayjs(value).format(DATE_FORMAT) : '-'),
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.deletion')}</>}</Translation>,
    dataIndex: 'deletionDate',
    render: (value) => (value ? dayjs(value).format(DATE_FORMAT) : '-'),
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.author')}</>}</Translation>,
    dataIndex: 'author',
    width: 150,
    render: (value: { displayName: string }) => value?.displayName,
  },
  {
    title: (
      <Translation>{(t) => <>{t('pages.raw-regulations.confirmation-period')}</>}</Translation>
    ),
    dataIndex: 'confirmationPeriod',
    render: (value: number) => CONFIRMATION_PERIOD[value as 1 | 2 | 3 | 4],
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.confirmation')}</>}</Translation>,
    dataIndex: 'confirmationDate',
    render: (value) => (value ? dayjs(value).format(DATE_FORMAT) : '-'),
  },
  {
    title: <Translation>{(t) => <>{t('pages.raw-regulations.is-confirmed')}</>}</Translation>,
    dataIndex: 'isValid',
    render: (value: number) =>
      value ? (
        <Translation>{(t) => <>{t('common.yes')}</>}</Translation>
      ) : (
        <Translation>{(t) => <>{t('common.no')}</>}</Translation>
      ),
  },
];

export const RAW_REGULATIONS_FORM_SCHEMA = Yup.object().shape({
  // name: Yup.string().required('Name is required'),
  // order: Yup.string().required('Order is required'),
  // type: Yup.string().required('Type is required'),
  // parentTopicId: Yup.string().required('Parent Topic is required'),
});

export const RAW_REGULATIONS_INITIAL_FORM_VALUES = {
  id: null,
  title: '',
  titleEnglish: '',
  isActive: true,
  author: null,
  type: null,
  emergedOut: '',
  confirmationPeriod: null,
  unitInChargeId: null,
  topics: [],
  targetGroupId: null,
  shortDescription: '',
  shortDescriptionEnglish: '',
  content: '',
};
